import type { IconSvgObject } from './types';

const BookmarkOff01Icon: IconSvgObject = [
  ["path", { d: "M2 2.00003L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 7.50003H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4.5 4.50003L4.5 21.5L12 17.5L19.5 21.5V19.5M7 2.50003H17.5C18.6046 2.50003 19.5 3.39546 19.5 4.50003V15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BookmarkOff01Icon;
